import { makeStyles } from '@material-ui/core';

export const produtoModalStyles = makeStyles(() => ({
  container: {
    flexGrow: 1,
    maxWidth: 600,
    width: '100%',
  },
}));
